import React from 'react';

export function SkipLinks() {
  return (
    <div className="skip-links">
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <a href="#sidebar" className="skip-link">
        Skip to sidebar
      </a>
    </div>
  );
}
